import { render, staticRenderFns } from "./JKScreen.vue?vue&type=template&id=b0e4f1bc"
import script from "./JKScreen.vue?vue&type=script&lang=js"
export * from "./JKScreen.vue?vue&type=script&lang=js"
import style0 from "./JKScreen.vue?vue&type=style&index=0&id=b0e4f1bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports